<script setup lang="ts">
import SVGWrapper from "./utils/SVGWrapper.vue";

import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
}

withDefaults(defineProps<IconProps>(), { size: "md" });
</script>

<template>
  <SVGWrapper :size="size" viewBox="0 0 24 24">
    <mask
      id="mask0_17114_57695"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="21"
      height="21"
    >
      <circle cx="11.9463" cy="11.8848" r="10" fill="#3F51B5" />
    </mask>
    <g mask="url(#mask0_17114_57695)">
      <circle cx="11.9471" cy="11.8845" r="10" fill="#3F51B5" />
      <path
        d="M2.73682 6.03688L9.21171 9.77516L8.6001 10.8345L2.12521 7.09621L2.73682 6.03688Z"
        fill="#E53935"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.37573 4.68623L10.5629 9.41312L8.96273 12.1848L0.77552 7.45788L2.37573 4.68623ZM2.73759 6.0367L2.12598 7.09603L8.60087 10.8343L9.21248 9.77498L2.73759 6.0367Z"
        fill="white"
      />
      <path
        d="M21.6092 17.6434L15.1343 13.9051L15.7459 12.8458L22.2208 16.584L21.6092 17.6434Z"
        fill="#E53935"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.9722 18.994L13.785 14.2671L15.3852 11.4955L23.5724 16.2224L21.9722 18.994ZM21.6103 17.6436L22.2219 16.5842L15.747 12.8459L15.1354 13.9053L21.6103 17.6436Z"
        fill="white"
      />
      <path
        d="M2.12665 16.6799L8.60154 12.9416L9.21314 14.0009L2.73825 17.7392L2.12665 16.6799Z"
        fill="#E53935"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.775024 16.3178L8.96223 11.5909L10.5624 14.3626L2.37524 19.0895L0.775024 16.3178ZM2.12549 16.6797L2.73709 17.739L9.21198 14.0007L8.60038 12.9414L2.12549 16.6797Z"
        fill="white"
      />
      <path
        d="M22.2213 7.0004L15.7464 10.7387L15.1348 9.67935L21.6096 5.94107L22.2213 7.0004Z"
        fill="#E53935"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.5709 7.36243L15.3837 12.0893L13.7835 9.31766L21.9707 4.59078L23.5709 7.36243ZM22.2205 7.00057L21.6089 5.94124L15.134 9.67952L15.7456 10.7389L22.2205 7.00057Z"
        fill="white"
      />
      <rect x="9.76709" y="1.88454" width="4.81464" height="20.4547" fill="white" />
      <rect
        x="22.4008"
        y="9.30392"
        width="4.97683"
        height="20.4547"
        transform="rotate(90 22.4008 9.30392)"
        fill="white"
      />
      <rect
        x="22.4008"
        y="10.2433"
        width="3.10002"
        height="20.4547"
        transform="rotate(90 22.4008 10.2433)"
        fill="#E53935"
      />
      <rect x="10.6245" y="1.56497" width="3.10002" height="20.4547" fill="#E53935" />
    </g>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
